'use client';

/**
 * Next.js global error boundary (BS-2146).
 *
 * NCUA examiner readiness: scrub PII before transmission per credit union
 * data handling policy. Captured errors flow through Sentry's beforeSend
 * hook which routes them through the PII scrubber before transmission.
 *
 * This file is the top-level error boundary that Next.js renders when the
 * root layout itself throws (errors below the layout are caught by the
 * SentryErrorBoundary wrapping children in `layout.tsx`).
 */
import * as Sentry from '@sentry/nextjs';
import NextError from 'next/error';
import { useEffect } from 'react';

interface GlobalErrorProps {
  error: Error & { digest?: string };
}

export default function GlobalError({ error }: GlobalErrorProps): React.JSX.Element {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        {/* NextError is Next's built-in static 500 page; statusCode 0 keeps
            the title generic since we don't have a real HTTP status here. */}
        <NextError statusCode={0} />
      </body>
    </html>
  );
}
